import { UserInSysAdminViewViewModel, User as UserViewModel } from '../../viewModels/User';
import { User as GraphqlUser, UserInSysAdminView } from '../generated/types';
import { ModuleId } from './module';

const mapToUserViewModel = (source: GraphqlUser): UserViewModel => {
    let result: UserViewModel = {
        email: source.email,
        id: source.id,
        firstName: source.firstName || '',
        lastName: source.lastName || '',
        role: source.role,
        assignedModuleIds: source.moduleIds as Array<ModuleId>,
        groupNames: source.groupNames,
        lastActivityDate: source.lastActivityDate ?? undefined,
    };
    if (source.invite) {
        result.invite = {
            status: source.invite.status,
        };
    }
    return result;
};

export const mapToUserListViewModel = (source: Array<GraphqlUser>) => source.map(mapToUserViewModel);

const mapToSysAdminUserViewModel = (source: UserInSysAdminView): UserInSysAdminViewViewModel => {
    let result: UserInSysAdminViewViewModel = {
        email: source.email,
        id: source.id,
        firstName: source.firstName || '',
        lastName: source.lastName || '',
        role: source.role || undefined,
        lastActivityDate: source.lastActivityDate ?? undefined,
        language: source.language || undefined,
        orgId: source.orgId || undefined,
        orgName: source.orgName || undefined,
    };

    if (source.invite) {
        result.invite = {
            status: source.invite.status,
        };
    }
    return result;
};
export const mapToUserListViewModelInSysAdminView = (source: Array<UserInSysAdminView>) => source.map(mapToSysAdminUserViewModel);


